<template>
  <div>
    <vs-card>
      <FormCancelamento
        :vistoria="false"
        @filtro="makeFiltro"
      ></FormCancelamento>
    </vs-card>

    <!--vs-card>
      <List
        :vistoria="true"
        :filtro="filtro"
        :realizaFiltro="realizaFiltro"
        @filtroOk="finalizaFiltro"
      ></List>
    </vs-card-->
  </div>
</template>

<script>
import List from "./../../lists/ListCancelamentos";
import FormCancelamento from "./../../forms/FormCancelamento";
export default {
  data() {
    return { realizaFiltro: false, filtro: null };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
  },
  components: {
    List,
    FormCancelamento,
  },
};
</script>


